<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'awaiting-payments'"
    :gcPopupConfig="gcPopupConfig"
    ref="awaiting-payment-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import TransactionListTemplate from "../../templates/transaction-list";
import {
  SuppliersTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/suppliers/suppliers-tabs";
import { SupplierInvoiceService } from "../../_services/api/purchasing/supplier-invoice.service";
export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,

      newDueDateModel: {
        NewDueDate: undefined,
      },
      AccountingPeriod: {
        StartDate: undefined,
        EndDate: undefined,
      },
      gcPopupVisible: false,
      NewDueDate: {
        Min: undefined,
        Max: undefined,
      },
    };
  },
  async created() {
    await SupplierInvoiceService.getActiveAccountingPeriodStartDate().then(
      (res) => {
        this.NewDueDate.Min = new Date(
          res.data.value[0].StartDate.replace("Z", "")
        );
      }
    );
    await SupplierInvoiceService.getActiveAccountingPeriodEndDate().then(
      (res) => {
        this.NewDueDate.Max = new Date(
          res.data.value[0].EndDate.replace("Z", "")
        );
      }
    );
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Awaiting Payments",
        ScreenName: "Awaiting Payments",
        exportFileName: "Awaiting Payments",
        selectedIndex: GetIndexByTabName("Awaiting Payments"),
        tabs: SuppliersTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SupplierTransactionHistory",
              filter: [
                ["SupplierTransactionType", "=", "Invoice"],
                "and",
                [
                  ["SupplierTransactionStatus", "=", "Overdue"],
                  "or",
                  ["SupplierTransactionStatus", "=", "Open"],
                ],
              ],
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.awaitingPaymentsPostProcess,
              remote: true,
            },
            noDataMessage: {},
            options: {
              selectionMode: "multiple",
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "New Batch Payment",
                route: "/supplier-batch-payment/create",
                visible:
                  FeatureStorage.checkPermission(
                    "BatchPaymentCommit",
                    "create"
                  ) ||
                  FeatureStorage.checkPermission("BatchPaymentSave", "create"),
                clickAction: {},
                buttonLocation: "left",
                routeQuery: {
                  from: "/supplier/awaiting-payment-list",
                },
              },
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Adjust Due Date",
                    },
                  ],
                  onItemClick: () => {
                    this.changeAllDueDateVisible();
                  },
                },
              },
            ],
          },
          columns: [
            {
              screenField: "DateIn",
              filterIndex: 2,
              allowHiding: true,
            },
            {
              screenField: "DateInto",
              label: "Date Created",
              dataField: "DateInto",
              filterIndex: 3,
              filterLabel: "Date Created",
              sortOrder: "desc",
              sortIndex: 0,
              visible: false,
            },
            {
              screenField: "SuppliersInvoiceDate",
              filterIndex: 4,
            },
            {
              screenField: "DueDate",
              filterIndex: 5,
            },
            {
              screenField: "Supplier",
              filterIndex: 6,
              gridDataField: "SupplierCode",
              filterDataField: "SupplierCode",
            },
            {
              screenField: "SupplierTransactionType",
              // filterIndex: 7,
              width: 75,
            },
            {
              screenField: "SupplierTransactionNumber",
              gridDataField: "TransactionNumber",
              label: "Transaction",
              width: 75,
              hyperlink: {
                url: "",
                gridUrlDataFields: ["SupplierTransactionType"],
                gridUrlConditions: [
                  {
                    values: [
                      {
                        SupplierTransactionType: "Payment",
                      },
                    ],
                    url: "supplier-payment/review/__ID__",
                  },
                  {
                    values: [
                      {
                        SupplierTransactionType: "Invoice",
                      },
                    ],
                    url: "supplier-invoice/review/__ID__",
                  },
                ],
                target: "_blank",
              },
              filterIndex: 0,
              type: "Integer",
              filterDataField: "TransactionNumber",
              filterLabel: "Transaction #",
            },
            {
              screenField: "SupplierReference",
              filterIndex: 1,
              filterLabel: "Supplier Reference",
              width: 100,
            },
            {
              screenField: "FXCurrencyCode",
              width: 70,
              filterIndex: 8,
            },

            {
              screenField: "Total",
              label: "Total (Base Currency)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "FXTotal",
              label: "Total (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "Allocated",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "FXAllocated",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "Discount",
              subTotal: "SUM",
              grandTotal: "SUM",
              visible: false,
            },
            {
              screenField: "FXDiscount",
              subTotal: "SUM",
              grandTotal: "SUM",
              label: "Discount (FX)",
              visible: false,
            },
            {
              screenField: "Balance",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "FXBalance",
              label: "Balance (FX)",
              subTotal: "SUM",
              grandTotal: "SUM",
            },
            {
              screenField: "SupplierTransactionStatus",
              dataSourceConfig: {
                data: ["Open", "Overdue"],
              },
              // filterDefaultValue: ["Open", "Overdue"],
              // filterIndex: 9,
            },
          ],
        },
      };

      return config;
    },

    gcPopupConfig() {
      return {
        title: "Adjust Due Date",
        dataModel: this.newDueDateModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 50,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "DueDate",
                dataField: "NewDueDate",
                label: {
                  text: "New Due Date",
                },
                editorOptions: {
                  min: this.NewDueDate.Min,
                  // max: this.NewDueDate.Max,
                  allowUpdate: true,
                  onValueChanged: (e) => {
                    if (e.event) {
                      if (new Date(e.value) < new Date(this.NewDueDate.Min)) {
                        e.component.beginUpdate();
                        e.component.option("value", e.previousValue);
                        e.component.endUpdate();
                      }
                    }
                  },
                },
              },
            ],
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          // disabled: !this.newDueDateModel.NewDueDate,
          disabled: this.SelectAllDueDate
            ? this.newDueDateModel.NewDueDate == undefined
            : this.newDueDateModel.NewDueDate == this.newDueDateModel.DueDate
            ? true
            : false,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
      };
    },
  },
  methods: {
    gcPopupCallBack() {
      this.gcPopupVisible = false;
    },
    awaitingPaymentsPostProcess(data) {
      data.forEach((element) => {
        element.DateIn = new Date(element.DateIn);
        element.DateInto = new Date(element.DateInto);
        element.SuppliersInvoiceDate = new Date(element.SuppliersInvoiceDate);
      });
      return data;
    },

    changeAllDueDateVisible() {
      this.newDueDateModel.NewDueDate = undefined;
      this.SelectAllDueDate = true;
      this.gcPopupVisible = true;
    },
    async onGcPopUpUpdate(e) {
      var payload = {
        DueDate: new Date(e.NewDueDate).toSaveDate(),
      };
      this.setLoading = true;
      let selectedRows =
        this.$refs["awaiting-payment-list"].$refs[
          "transactionListGrid"
        ].selectedRowData();
      payload.Invoices = selectedRows.map((x) => x.TransactionNumber);
      this.gcPopupCallBack();
      await SupplierInvoiceService.saveSupplierInvoiceDueDateBulkUpdate(payload)
        .then((res) => {
          if (res) this.setLoading = false;
          let dataGrid =
            this.$refs["awaiting-payment-list"].$refs[
              "transactionListGrid"
            ].getGridInstance();
          if (dataGrid) {
            dataGrid.deselectAll();
          }

          this.$notify(`Invoice Due Dates Successfully Updated`, "success");

          this.$refs["awaiting-payment-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.setLoading = false;
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
        });
    },
  },
};
</script>
